// extracted by mini-css-extract-plugin
export var contentContainer = "index-module--contentContainer--yExUM";
export var description = "index-module--description--JRYMZ";
export var keyword = "index-module--keyword--uOwEW";
export var keywordsArea = "index-module--keywordsArea--lWkFs";
export var linkArea = "index-module--linkArea--nVUL2";
export var tag = "index-module--tag--mLhnX";
export var tagArea = "index-module--tagArea--iYikA";